import { apolloClient } from "../services/vue-apollo";
import { FileUploadWorkerInfo } from "./file-upload-worker-info-model";
import { FileMultipartUploadWorkerInfo } from "./file-multipart-upload-worker-info-model";
import {
  COMPLETE_INSTA360_UPLOAD_MULTIPART,
  GET_INSTA360_UPLOAD_MULTIPART_INFO,
  GET_INSTA360_UPLOAD_URL,
} from "../graphql/package-upload-queries";

export class Insta360UploadWorkerInfo extends FileUploadWorkerInfo {
  projectId: number;

  constructor(file: File, projectId: number) {
    super(file);
    this.projectId = projectId;
  }

  startUpload() {
    apolloClient
      .query({
        query: GET_INSTA360_UPLOAD_URL,
        variables: { projectId: this.projectId, filename: this.file.name },
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        this.startSinglePartUpload(res.data.getInsta360UploadSignedURL);
      })
      .catch((ex) => {
        console.error(ex);
        if (this.onError) {
          this.onError(ex);
        }
      });
  }
}

export class Insta360MultipartUploadWorkerInfo extends FileMultipartUploadWorkerInfo {
  projectId: number;

  constructor(file: File, projectId: number) {
    super(file);
    this.projectId = projectId;
  }

  startUpload() {
    apolloClient
      .query({
        query: GET_INSTA360_UPLOAD_MULTIPART_INFO,
        variables: {
          projectId: this.projectId,
          filename: this.file.name,
          numberOfParts: this.numberOfParts,
        },
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        this.startMultipartUpload(res.data.getInsta360UploadMultipartInfo);
      })
      .catch((ex) => this.handleError(ex, () => this.startUpload()));
  }

  completeMultipartUpload(eTags: string[]) {
    this.progressMonitor.setComplete();
    this.state.setComplete();

    apolloClient
      .mutate({
        mutation: COMPLETE_INSTA360_UPLOAD_MULTIPART,
        variables: {
          projectId: this.projectId,
          filename: this.file.name,
          uploadId: this.uploadId,
          eTags: eTags.join(","),
        },
      })
      .then(() => {
        if (this.onComplete) this.onComplete();
      })
      .catch((ex) => {
        if (this.onError) this.onError(ex);
      });
  }
}
